import { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { Reminder } from "shared/network/reminder.api";

const RestoreSaved = ({
  reminder,
  reminderOpen,
  setValue,
}: {
  reminder?: Reminder | null;
  reminderOpen: boolean;
  setValue: any;
}) => {
  // ...a dialog komponenseden belül:
  const [showRestorePrompt, setShowRestorePrompt] = useState(false);
  const [restoreContent, setRestoreContent] = useState("");

  useEffect(() => {
    let saved: string | null = null;
    if (reminderOpen) {
      if (reminder?.id) {
        saved = localStorage.getItem(`reminderFormContent-${reminder?.id}`);
      } else {
        saved = localStorage.getItem("reminderFormContent");
      }
      if (saved) {
        setRestoreContent(saved);
        setShowRestorePrompt(true);
      }
    }
  }, [reminder?.id, reminderOpen]);

  const handleRestore = () => {
    setValue("reminderMessage", restoreContent);
    setShowRestorePrompt(false);
  };

  const handleSkipRestore = () => {
    setShowRestorePrompt(false);
    if (reminder?.id) {
      localStorage.removeItem(`reminderFormContent-${reminder?.id}`);
    } else {
      localStorage.removeItem("reminderFormContent");
    }
  };
  console.log(reminder?.reminderMessage);
  return (
    <Dialog open={showRestorePrompt} onClose={handleSkipRestore}>
      <DialogTitle>Félbehagyott szöveg</DialogTitle>
      <DialogContent>
        Szeretnéd visszatölteni a korábban mentett, félbehagyott szöveget?
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSkipRestore} variant="text">
          Nem
        </Button>
        <Button onClick={handleRestore} color="primary" variant="contained">
          Igen, visszatöltöm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RestoreSaved;
